import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=5132f7e2&"
import script from "./GenericTable.vue?vue&type=script&lang=js&"
export * from "./GenericTable.vue?vue&type=script&lang=js&"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=5132f7e2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports